export function formatSalaryChartData(chartData) {
  console.log('formatSalaryChartData', chartData);
  let dataArray = [];
  let dataObj = {};

  let prevYear = '2011-2012';

  chartData.forEach((element) => {
    //console.log('chart for each', element);
    let thisYear = element.year;
    /* console.log('thisYear', thisYear);
    console.log('prevYear', prevYear); */

    if (thisYear === prevYear) {
      //console.log('same year', thisYear);

      if (element.Staff === 'TOTAL TEACHING STAFF') {
        //console.log('TOTAL TEACHING STAFF', element);
        dataObj.teaching_staff_cnt = element.FTE_Count;
        dataObj.teaching_staff_avg = element.Average_Base_Pay;
        dataObj.teaching_staff_total = element.Total_Base_Pay;
      }

      if (element.Staff === 'PRINCIPAL') {
        //console.log('PRINCIPAL', element);
        dataObj.principal_cnt = element.FTE_Count;
        dataObj.principal_avg = element.Average_Base_Pay;
        dataObj.principal_total = element.Total_Base_Pay;
      }

      if (element.Staff === 'TOTAL ADMINISTRATIVE STAFF') {
        //console.log('TOTAL ADMINISTRATIVE STAFF', element);
        dataObj.administrative_staff_cnt = element.FTE_Count;
        dataObj.administrative_staff_avg = element.Average_Base_Pay;
        dataObj.administrative_staff_total = element.Total_Base_Pay;
      }

      if (element.Staff === 'SUPERINTENDENT') {
        //console.log('SUPERINTENDENT', element);
        dataObj.superintendent_cnt = element.FTE_Count;
        dataObj.superintendent_avg = element.Average_Base_Pay;
        dataObj.superintendent_total = element.Total_Base_Pay;
      }
    } else {
      //console.log(`thisYear ${thisYear} prevYear ${prevYear}`);
      dataArray.push(dataObj);
      prevYear = element.year;
      dataObj = {};
    }
    dataObj.year = element.year;
    dataObj.order = getYearOrder(element.year);
  });
  //console.log('final dataArray', dataArray);
  return dataArray.sort((firstItem, secondItem) => firstItem.order - secondItem.order);
}

function getYearOrder(year) {
  let orderValue;
  switch (year) {
    case '2011-2012':
      orderValue = 1;
      break;

    case '2012-2013':
      orderValue = 2;
      break;

    case '2013-2014':
      orderValue = 3;
      break;
    case '2014-2015':
      orderValue = 4;
      break;

    case '2015-2016':
      orderValue = 5;
      break;

    case '2016-2017':
      orderValue = 6;
      break;
    case '2017-2018':
      orderValue = 7;
      break;

    case '2018-2019':
      orderValue = 8;
      break;

    case '2019-2020':
      orderValue = 9;
      break;

    case '2020-2021':
      orderValue = 10;
      break;

    default:
      orderValue = 1;
  }
  return orderValue;
}

export function formatEnrollmentChartData(inData) {
    console.log('formatEnrollmentChartData', inData);
    let dataArray = [];
    let dataObj = {};
  
    let prevYear = '2011-2012';
  
    inData.forEach((element) => {
      //console.log('chart for each', element);
      let thisYear = element.year;
      /* console.log('thisYear', thisYear);
      console.log('prevYear', prevYear); */
  
      if (thisYear === prevYear) {
        console.log('same year', thisYear);
  
        if (element.Staff === 'TOTAL TEACHING STAFF') {
          console.log('TOTAL TEACHING STAFF', element);
          dataObj.teaching_staff_cnt = element.FTE_Count;
          dataObj.teaching_staff_avg = element.Average_Base_Pay;
          dataObj.teaching_staff_total = element.Total_Base_Pay;
        }
  
        if (element.Staff === 'PRINCIPAL') {
          console.log('PRINCIPAL', element);
          dataObj.principal_cnt = element.FTE_Count;
          dataObj.principal_avg = element.Average_Base_Pay;
          dataObj.principal_total = element.Total_Base_Pay;
        }
  
        if (element.Staff === 'TOTAL ADMINISTRATIVE STAFF') {
          console.log('TOTAL ADMINISTRATIVE STAFF', element);
          dataObj.administrative_staff_cnt = element.FTE_Count;
          dataObj.administrative_staff_avg = element.Average_Base_Pay;
          dataObj.administrative_staff_total = element.Total_Base_Pay;
        }
  
        if (element.Staff === 'SUPERINTENDENT') {
          console.log('SUPERINTENDENT', element);
          dataObj.superintendent_cnt = element.FTE_Count;
          dataObj.superintendent_avg = element.Average_Base_Pay;
          dataObj.superintendent_total = element.Total_Base_Pay;
        }
      } else {
        console.log(`thisYear ${thisYear} prevYear ${prevYear}`);
        dataArray.push(dataObj);
        prevYear = element.year;
        dataObj = {};
      }
      dataObj.year = element.year;
      dataObj.order = getYearOrder(element.year);
    });
    console.log('final dataArray', dataArray);
    return dataArray.sort((firstItem, secondItem) => firstItem.order - secondItem.order);
  }

  /**
 * @param  {} appName
 */
export function formatAppName(appName) {
    let appArray = [];
    let appObj = {};
    appName.forEach(function (value, index) {
      appObj.appId = value.appId;
      appObj.appName = value.appId + ':' + value.applicationName;
      appArray.push(appObj);
      appObj = {};
    });
  
    console.log('appArray', appArray);
    /* options: props.locations.map(option => option.street + ' ' + option.city + ' ' + option.state + ' ' + option.zip) */
    return appArray;
  }
  
  /**
   * @param  {} appData
   */
  export function formatAppData(appData) {
    let appArray = [];
    let appObj = {};
    appData.forEach(function (value, index) {
      /* appObj.appId = value.appId;
          appObj.appName = value.appId + ':' + value.applicationName; */
      appObj.appId = value.id.appId;
      appObj.appName = value.id.appId + ':' + value.id.applicationName;
      appArray.push(appObj);
      appObj = {};
    });
  
    console.log('appDataArray', appArray);
    /* options: props.locations.map(option => option.street + ' ' + option.city + ' ' + option.state + ' ' + option.zip) */
    return appArray;
  }
  
  /**
   * @param  {} objArr
   * @param  {} srchKey
   * @param  {} srchValue
   */
  export function filterObjectArray(objArr, srchKey, srchValue) {
    console.log('filterObjectArray:', objArr);
    let results = objArr.filter((obj) => obj[srchKey] === srchValue);
    return results;
  }
  
  /**
   * @param  {} date
   */
  export function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return [month, day, year].join('/');
  }
  
  /**
   * @param  {} jsonDate
   */
  export function formatJSONDate(jsonDate) {
    console.log('jsonDate', jsonDate);
    var newDate = new Date(jsonDate);
    console.log('newDate', newDate);
    var json = newDate.toJSON();
    return json;
  }
  
  /**
   * @param  {} permArr
   * @param  {} permValue
   */
  export function checkPermValue(permArr, permValue) {
    let hasValue = permArr.filter((perm) => perm.includes(permValue));
    return hasValue.length > 0;
  }
  
  